import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { Avatar } from '@mantine/core';
import { Adminauthcontexthooks } from '../../Hooks/Adminauthcontexthooks';


const Exstusertable = () => {
    const columns = [
        {
            title: 'Name',
            dataIndex: 'Fullname',
            key: 'Fullname',
        },
        {
            title: 'Phone No',
            dataIndex: 'PhoneNumber',
            key: 'PhoneNumber',
        },
        {
            title: 'Email',
            dataIndex: 'Email',
            key: 'Email',
        },
        {
            title: 'Created at',
            dataIndex: 'createdAt',
            key: 'createdAt',
        },
        {
            title: 'Photo',
            dataIndex: 'Photo',
            key: 'Photo',
            render: (photo, record) => (
                <Avatar
                    src={photo}
                    name={record.Fullname}
                    alt={record.Fullname}
                    color="orange"
                />
            )
        },
    ];
    const { user } = Adminauthcontexthooks()
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);

    useEffect(() => {
        if (user) {
            const Get_All_Users = async () => {
                const res = await fetch('https://cdr-backend.onrender.com/get/all-users', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user}`
                    }
                });
                if (res.status === 200) {
                    const data = await res.json();
                    setdata(data.Allusers);
                    setloading(false);
                    return
                }
            }

            Get_All_Users();
        }
    }, [loading, user])

    return (
        <>
            <Table columns={columns} dataSource={data} loading={loading} />
        </>
    )
}

export default Exstusertable;